import { Button, makeStyles, TableCell, TableRow } from '@material-ui/core';
import React from 'react'
import { getTraerSolicitudBandejaImagenesSurge } from '../../../../../../actions/autorizaciones/Autorizaciones';
import { useDispatch } from 'react-redux';

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};


export const ItemsSolicitudes = (props) => {

  const classes = useRowStyles();
  const dispatch = useDispatch();
  const { item, setOpenModalInfo } = props;

  return (
    <TableRow className={classes.root}>
      <TableCell align="left"></TableCell>
      <TableCell align="left">
        {new Date(item?.fecha).toLocaleString("es", optionsfecha)}
      </TableCell>
      <TableCell align="left">{item?.idSolicitud}</TableCell>
      <TableCell align="left">{item?.carnet}</TableCell>
      <TableCell align="left">{item?.apellido_nombre} </TableCell>
      <TableCell align="left">{item?.practica}</TableCell>
      <TableCell align="left">{item?.cant}</TableCell>
      <TableCell align="left">{item?.problema}</TableCell>
      <TableCell align="left">
        <Button
          style={{ fontSize: "0.8rem" }}
          variant="contained"
          color="primary"
          onClick={() => {
            dispatch(getTraerSolicitudBandejaImagenesSurge(item?.idSolicitud, item.idEstadoSolicitud, setOpenModalInfo))
          }}
        >
          Abrir
        </Button>
      </TableCell>
    </TableRow>
  )
}

